import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, ServerIcon, CodeIcon, HandshakeIcon } from 'lucide-react';
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function BusinessModelSlide() {
  return <motion.div className="w-full h-full flex flex-col px-12 py-10" variants={stagger} initial="hidden" animate="visible" data-id="element-100">
      <motion.div variants={fadeUp} className="flex items-center gap-3 mb-2" data-id="element-101">
        <span className="text-base text-[#ff6b35] font-semibold tracking-widest uppercase" data-id="element-102">
          06
        </span>
        <span className="w-8 h-[1px] bg-[#ff6b35] opacity-50" data-id="element-103" />
      </motion.div>

      <motion.h2 variants={fadeUp} className="text-4xl md:text-5xl font-extrabold text-white mb-3" data-id="element-104">
        Business Model
      </motion.h2>

      <motion.p variants={fadeUp} className="text-2xl text-[#8899aa] mb-8" data-id="element-105">
        Usage-based pricing: price per million inferences
      </motion.p>

      <div className="flex-1 flex flex-col gap-5" data-id="element-106">
        {/* Revenue split */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-107">
          <motion.div variants={fadeUp} className="glass-card p-6" data-id="element-108">
            <div className="flex items-center gap-3 mb-3" data-id="element-109">
              <div className="w-9 h-9 rounded-lg bg-[rgba(0,212,255,0.1)] flex items-center justify-center" data-id="element-110">
                <CreditCardIcon className="w-4 h-4 text-[#00d4ff]" data-id="element-111" />
              </div>
              <div data-id="element-112">
                <p className="text-base text-[#00d4ff] font-semibold uppercase tracking-wider" data-id="element-113">
                  Revenue 1
                </p>
                <p className="text-2xl font-bold text-white" data-id="element-114">40%</p>
              </div>
            </div>
            <p className="text-[20px] text-white/80 leading-relaxed" data-id="element-115">
              5% FPGA inference gateway platform fee on usage/credits with
              tiered plans.
            </p>
          </motion.div>

          <motion.div variants={fadeUp} className="glass-card p-6" data-id="element-116">
            <div className="flex items-center gap-3 mb-3" data-id="element-117">
              <div className="w-9 h-9 rounded-lg bg-[rgba(255,107,53,0.1)] flex items-center justify-center" data-id="element-118">
                <ServerIcon className="w-4 h-4 text-[#ff6b35]" data-id="element-119" />
              </div>
              <div data-id="element-120">
                <p className="text-base text-[#ff6b35] font-semibold uppercase tracking-wider" data-id="element-121">
                  Revenue 2
                </p>
                <p className="text-2xl font-bold text-white" data-id="element-122">60%</p>
              </div>
            </div>
            <p className="text-[20px] text-white/80 leading-relaxed" data-id="element-123">
              We supply FPGA inference to the gateway (own/rent)
            </p>
          </motion.div>
        </div>

        {/* Revenue bar visualization */}
        <motion.div variants={fadeUp} className="glass-card p-5" data-id="element-124">
          <div className="flex h-5 rounded-full overflow-hidden" data-id="element-125">
            <div className="bg-[#00d4ff] w-[40%] flex items-center justify-center" data-id="element-126">
              <span className="text-base font-bold text-deep" data-id="element-127">
                Platform 40%
              </span>
            </div>
            <div className="bg-[#ff6b35] w-[60%] flex items-center justify-center" data-id="element-128">
              <span className="text-base font-bold text-deep" data-id="element-129">Supply 60%</span>
            </div>
          </div>
          <p className="text-center text-xl text-white/80 mt-3 font-medium" data-id="element-130">
            2-10X Cheaper or 2-5X faster than GPU tokens/$
          </p>
        </motion.div>

        {/* Wedge & Expand */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-131">
          <motion.div variants={fadeUp} className="glass-card p-5 flex gap-3 items-start" data-id="element-132">
            <CodeIcon className="w-5 h-5 text-[#00d4ff] mt-0.5 flex-shrink-0" data-id="element-133" />
            <div data-id="element-134">
              <p className="text-base text-[#00d4ff] font-semibold uppercase tracking-wider mb-1" data-id="element-135">
                Wedge
              </p>
              <p className="text-[20px] text-white/80 leading-relaxed" data-id="element-136">
                Easy open-source LLM inference API integration for vertical apps
              </p>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} className="glass-card p-5 flex gap-3 items-start" data-id="element-137">
            <HandshakeIcon className="w-5 h-5 text-[#ff6b35] mt-0.5 flex-shrink-0" data-id="element-138" />
            <div data-id="element-139">
              <p className="text-base text-[#ff6b35] font-semibold uppercase tracking-wider mb-1" data-id="element-140">
                Expand
              </p>
              <p className="text-[20px] text-white/80 leading-relaxed" data-id="element-141">
                Partner with cutting edge models
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.div>;
}